//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: true,
    },

    data() {
        return {
            wrapper: {
                value: null,
            },
            status: 'hide',
        };
    },

    methods: {
        // Save and close (when wrapper is used)
        save() {
            this.$refs.popup?.set();
        },
        // Cancel and close (when wrapper is used)
        cancel() {
            this.cancelOrClose();
        },
        // Close (when wrapper is not used)
        close() {
            this.cancelOrClose();
        },
        cancelOrClose() {
            this.$refs.popup?.cancel();
        },
        closeOnClick() {
            if (this.status === 'show') {
                this.save();
            }
        },
        closeOnEscape(ev) {
            if (ev.which === 27 && this.status === 'show') {
                this.cancelOrClose();
            }
        },
        onBeforeShow() {
            window.addEventListener('click', this.closeOnClick);
            window.addEventListener('keyup', this.closeOnEscape);

            this.wrapper.value = this.value;
            this.status = 'before-show';
            this.$emit('before-show');
        },
        onShow() {
            this.status = 'show';
            this.$emit('show');
        },
        onSave() {
            this.$emit('input', this.wrapper.value);
            this.$emit('save', this.wrapper.value, this.value);
        },
        onCancel() {
            this.$emit('cancel', this.wrapper.value, this.value);
        },
        onBeforeHide() {
            window.removeEventListener('click', this.closeOnClick);
            window.removeEventListener('keyup', this.closeOnEscape);

            this.status = 'before-hide';
            this.$emit('before-hide');
        },
        onHide() {
            this.wrapper.value = null;
            this.status = 'hide';
            this.$emit('hide');
        },
    },
};
